import { SubmitHandlerWithDirtyFields } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { getGetInvoicesPaginatedDefaultValues } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/invoices/models/inputs/get-invoices-paginated.form-default-values';
import { GetInvoicesPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/invoices/models/inputs/get-invoices-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { Logger } from '@app/core/logger/logger';

import {
  FilterInvoiceListContextProvider,
  useInvoiceListContext,
} from '../invoice.context';
import { InvoiceListFilterFormController } from './invoice-list-filter-form/invoice-list-filter-form.controller';

interface InvoiceListFilterControllerProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export const InvoiceListFilterController = ({
  onCancel,
  onSuccess,
}: InvoiceListFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();
  const { getPaginatedQueryParameters, setGetPaginatedQueryParameters } =
    useInvoiceListContext();

  // HANDLERS //////////////////////////////////////////////////////////////////

  const handleError: SubmitErrorHandler<GetInvoicesPaginatedModel> = (
    errors,
  ) => {
    Logger.error(errors);
    toast.error(
      t('$.channel-list-filter.error', { error: t('global.unknown') }),
    );
  };

  const handleSubmit: SubmitHandlerWithDirtyFields<
    GetInvoicesPaginatedModel
  > = (fieldValues) => {
    setGetPaginatedQueryParameters((current) => {
      return {
        ...current,
        customerId: fieldValues.customerId,
        networkId: fieldValues.networkId,
        status: fieldValues.status,
        type: fieldValues.type,
      };
    });
    onSuccess();
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  const data = getGetInvoicesPaginatedDefaultValues(
    getPaginatedQueryParameters,
  );

  return (
    <FilterInvoiceListContextProvider data={data}>
      <InvoiceListFilterFormController
        onError={handleError}
        onSubmit={handleSubmit}
        onCancel={onCancel}
      />
    </FilterInvoiceListContextProvider>
  );
};
